import { CheckboxOnChangeData } from "@fluentui/react-components";
import { ChangeEvent, useEffect, useState } from "react";
import { IOption } from "../Field/DropdownField";
import { Checkbox, ETheme } from "..";

interface CheckboxCustomProps {
  theme?: ETheme;
  options: IOption[];
  rcName?: string;
  values?: string[];
  onChange?: (values: string[]) => void;
}

const CheckboxGroup = (props: CheckboxCustomProps) => {
  const [values, setValues] = useState<string[]>([]);

  useEffect(() => {
    setValues([...(props.values || [])]);
  }, [props.values]);

  const onChange = (
    _ev: ChangeEvent<HTMLInputElement>,
    data: CheckboxOnChangeData,
    value: string
  ) => {
    const { checked } = data;
    const valuesClone = [...values];
    if (checked && !values.includes(value)) {
      valuesClone.push(value);
      setValues(valuesClone);
      if (props.onChange) {
        props.onChange(valuesClone);
      }
    } else if (!checked && valuesClone.includes(value)) {
      const index = values.indexOf(value);
      if (index > -1) {
        valuesClone.splice(index, 1);
        setValues(valuesClone);
        if (props.onChange) {
          props.onChange(valuesClone);
        }
      }
    }
  };
  return (
    <>
      {props.options.map((option) => (
        <Checkbox
          key={option.value}
          label={option.text}
          checked={(values || [])?.includes(option.value)}
          theme={props.theme}
          onChange={(
            ev: ChangeEvent<HTMLInputElement>,
            data: CheckboxOnChangeData
          ) => onChange(ev, data, option.value)}
        />
      ))}
    </>
  );
};
export default CheckboxGroup;
